export const STEP_LIST_PERSONAL = [
  {
    title: '个人认证',
    description: '提升个人账户信用度与安全保障'
  },
  { title: '活体认证', description: '核实用户身份信息和真人，提升其真实性' },
  { title: '认证完毕', description: '认证完毕，开启购物之旅' }
]

export const OTHER_STEP_LIST = [
  {
    title: '个人认证',
    description: '提升个人账户信用度与安全保障'
  },
  { title: '认证完毕', description: '认证完毕，开启购物之旅' }
]

export const CardTypeEnum = {
  'SFZ': 'SFZ',
  'GATJMJZZ': 'GATJMJZZ',
  'HZ': 'HZ'
}

export const AuthTypeEnum = {
  PERSONAL: 'PERSONAL',
  COMPANY: 'COMPANY'
}

export const SexEnum = {
  M: 'M',
  F: 'F'
}

export const PortEnum = {
  PC: 'pc',
  WECHAT: 'wechat'
}

export const CARD_TYPES = [
  {
    value: CardTypeEnum.SFZ,
    label: '身份证'
  },
  {
    value: CardTypeEnum.GATJMJZZ,
    label: '港澳通行证'
  },
  {
    value: CardTypeEnum.HZ,
    label: '护照'
  }
]

export const PORT_TYPE_LIST = [
  {
    value: PortEnum.PC,
    label: '电脑端认证'
  },
  {
    value: PortEnum.WECHAT,
    label: '微信扫描认证'
  }
]

export const SEX_LIST = [
  {
    value: SexEnum.M,
    label: '男'
  },
  {
    value: SexEnum.F,
    label: '女'
  }
]

export const CheckStatusEnum = {
  NO: 'NO',
  FAIL: 'FAIL',
  VERIFYING: 'VERIFYING',
  VERIFIED: 'VERIFIED'
}

export const PERSONAL_CERTIFICATION = 'PERSONAL_CERTIFICATION'

export const ImageTypeEnum = {
  ID_CARD_IMAGE: 'ID_CARD_IMAGE',
  PASSPORT: 'PASSPORT',
  TRAFFIC_PERMIT: 'TRAFFIC_PERMIT',
  ID_CARD_IMAGE_1: 'ID_CARD_IMAGE_1', // 身份证正面
  ID_CARD_IMAGE_2: 'ID_CARD_IMAGE_2', // 身份证反面
  PASSPORT_1: 'PASSPORT_1', // 护照证件正面照
  PASSPORT_2: 'PASSPORT_2', // 护照证件正面照
  TRAFFIC_PERMIT_1: 'TRAFFIC_PERMIT_1', // 通信证证件正面照
  TRAFFIC_PERMIT_2: 'TRAFFIC_PERMIT_2', // 通信证证件反面照
  AUTHORIZATION: 'AUTHORIZATION', // 授权页
  COMPANY_IMAGE: 'COMPANY_IMAGE', // 公司营业执照,
  FACE_IMAGE: 'FACE_IMAGE' // 人脸照片
}

export const STATUS_STAMP_MAP = {
  [CheckStatusEnum.VERIFIED]:
      'https://assets.chinagoods.com/libs/cgf/static/images/1675749671000passed.svg',
  [CheckStatusEnum.FAIL]:
      'https://assets.chinagoods.com/libs/cgf/static/images/1675749655000failure.svg',
  [CheckStatusEnum.VERIFYING]:
      'https://assets.chinagoods.com/libs/cgf/static/images/1675749633000checking.svg'
}

export const OCRActionTypeEnum = {
  IDCardOCR: 'IDCardOCR',
  BizLicenseOCR: 'BizLicenseOCR'
}

export const STEP_LIST_COMPANY = [
  {
    title: '企业信息填报',
    description: '请进行企业信息填报'
  },
  {
    title: '认证完成',
    description: '认证完毕，开启购物之旅'
  }
]

export const CompanyTypeEnum = {
  INDIVIDUAL: 0,
  LIMITED: 1
}

export const COMPANY_TYPE = [
  {
    label: '个体工商户',
    value: CompanyTypeEnum.INDIVIDUAL
  },
  {
    label: '有限公司',
    value: CompanyTypeEnum.LIMITED
  }
]
